
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "1f112a61-6414-4cc9-b3f9-949362da97d4"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/prow/go/src/github.com/bittorrent/ads-content-website/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
